export const createShopifyOrder = async (payload) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/shopify/create-order`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to create Shopify order");
  }

  return await response.json();
};
